import React from "react";

export default function LoadingDots() {
  return (
    <div className="w-full h-full min-h-[50vh] flex items-center justify-center bg-white z-50">
      <div className="flex space-x-2">
        <span className="w-3 h-3 bg-blue-500 rounded-full animate-bounce"></span>
        <span className="w-3 h-3 bg-blue-500 rounded-full animate-bounce [animation-delay:0.2s]"></span>
        <span className="w-3 h-3 bg-blue-500 rounded-full animate-bounce [animation-delay:0.4s]"></span>
        <span className="w-3 h-3 bg-blue-500 rounded-full animate-bounce [animation-delay:0.6s]"></span>
      </div>
    </div>
  );
}
